/**
 * Gamification i18n labels (badges/achievements).
 *
 * The `gamification-core` core is i18n-AGNOSTIC: a badge is identified by
 * its stable `id` (e.g. `"first-lesson"`) and does NOT render text. Here the
 * web app maps each id to a translatable `MessageDescriptor` (`BLOCK_KINDS` pattern).
 * Consumers render with `t(BADGE_LABELS[id])`.
 */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

/** id de badge (de `spaceGamificationConfig.badges`) → etiqueta localizada. */
const BADGE_LABELS: Record<string, MessageDescriptor> = {
  "first-lesson": msg`First lesson`,
  "ten-lessons": msg`10 lessons`,
  "hundred-lessons": msg`100 lessons`,
  "streak-7": msg`7-day streak`,
  "streak-30": msg`30-day streak`,
  "first-course": msg`First course completed`,
  scholar: msg`Scholar (level 5)`,
  sage: msg`Sage (level 10)`,
};

/** A badge's label by id, falling back to the id itself if unmapped. */
export function badgeLabel(id: string): MessageDescriptor | string {
  return BADGE_LABELS[id] ?? id;
}
